"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Wrap the block in a new blockquote.
 */
var wrapInBlockquote = function (opts) { return function (editor) {
    return editor.wrapBlock(opts.type);
}; };
exports.default = wrapInBlockquote;
//# sourceMappingURL=wrapInBlockquote.js.map